import { useCallback } from "react";

import { getEntryData } from "@api/entryData/entryData";
import { useUpdateEntryDataOnly } from "@stores/entryData";
import { getPressIdFromURL } from "@utils/getStateFromURL";

export const useGetCurrentEntryData = (draftArticleId?: string) => {
  const setEntryData = useUpdateEntryDataOnly();

  const getEntryDataAndStored = useCallback(async () => {
    const data = await getEntryData(draftArticleId || getPressIdFromURL());
    setEntryData(draftArticleId || getPressIdFromURL(), data);
  }, [setEntryData, draftArticleId]);

  return getEntryDataAndStored;
};
